export default "__VITE_ASSET__240a6633__"